/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Automatic Discount for customer groups
//  var productMetaPrices = elm.closest('.Modal--quickbuy').find('.ProductMeta__PriceList');
    
//  var cd = elm.closest('.ProductItem__Wrapper').find('.customer--discount').val();
 
//  var priceHtml = '';

//  if (found['compare_at_price'] > found['price']) {
//    priceHtml += '<span class="ProductMeta__Price Price Price--highlight Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'], window.theme.moneyFormat) + '</span>';
//    priceHtml += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['compare_at_price'], window.theme.moneyFormat) + '</span>';
//  } else {
//    if(cd != undefined){

//      priceHtml += '<span class="ProductMeta__Price Price Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'] * cd, window.theme.moneyFormat) + '</span>';
//      priceHtml += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'], window.theme.moneyFormat) + '</span>';
//    } else {
//        priceHtml += '<span class="ProductMeta__Price Price Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'], window.theme.moneyFormat) + '</span>';
//    }
   
//  }


// custom js
 function incrementValue(id) {
  var value = parseInt(document.getElementById('quickbuy_quantitySelector' + id).value);
  value++;
     console.log
  document.querySelector('#quickbuy_quantitySelector' + id).setAttribute("value",value);
}
function decrementValue(id) {
  var value = parseInt(document.getElementById('quickbuy_quantitySelector' + id).value);
  if(value > 0) {
    value--;
  }
  document.querySelector('#quickbuy_quantitySelector' + id).setAttribute("value",value);
}

$(document).ready(function()
 {
 
  $(document).on('click','.Modal--quickbuy .ProductForm [data-action="add-to-cart"]', function(e) 
  {
    var option_name = '';
    var arrString0 = '';
    var arrString1 = '';
    var arrString2 = '';
    var arrString3 = '';
    var arrString4 = '';
   var arr = [];
   var thelistunique = '';
    var select_val_option = '';
    $(this).closest('form').find(".ProductForm__Option li").each(function( index ){
  var input_vlue = $(this).closest('.SizeSwatchList').find('.cstm_active').val();
  if( input_vlue == "undefined" || input_vlue == "" ){}
  else {
    arr.push(input_vlue);
    // console.log(input_vlue + index, arr);
  var thelistunique = arr.filter(function(a){
    if (!this[a]) {
      this[a] = 1;
      return a;
    }},{});
    // var max_length_list = $(thelistunique).length;
    arrString0 = thelistunique[0];
    arrString1 = thelistunique[1];
    arrString2 = thelistunique[2];
    arrString3 = thelistunique[3];
    arrString4 = thelistunique[4];
    if (arrString0 && arrString1 && arrString2 && arrString3 && arrString4){
     option_name = arrString0 + " / "+ arrString1 + " / " + arrString2 + " / "+ arrString3 + " / " + arrString4; 
    } else if (arrString0 && arrString1 && arrString2 && arrString3) {
     option_name = arrString0 + " / "+ arrString1 + " / " + arrString2 + " / "+ arrString3; 
    }  else if (arrString0 && arrString1 && arrString2 ) {
     option_name = arrString0 + " / "+ arrString1 + " / " + arrString2 ; 
    }  else if (arrString0 && arrString1) {
     option_name = arrString0 + " / "+ arrString1; 
    }  else if (arrString0) {
     option_name = arrString0; 
    }
  }
});
var select_val = '';
    $(this).closest('form').find(".ProductForm__Option select option").each(function( index ){
      var select_val = $(this).attr('data-var');
      if( option_name == select_val ){
      select_val_option = $(this).val();
        $(this).attr('selected', 'selected');
     } else {
   // console.log('not');
        
     }
      // console.log(select_val_option, 'select_val_options');
  });

    e.preventDefault();
    //console.log(select_val_option);
    var parent = $(this).parent('.Modal--quickbuy');
    var formData = $(this).closest('form').serialize();
    var prdct_id = $(this).closest('form').attr('id');
    // console.log(formData, 'formData');
     document.dispatchEvent(new CustomEvent('theme:loading:start'));
    $.ajax({
      type:"post",
      dataType: "json",
      url: '/cart/add.js',
      data:formData,
      success: function(data){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        })); 
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        // parent.find('[data-action="close-modal"]').trigger('click');
        $('.modal-top button')[0].click();
        setTimeout(function(){
         $('#sidebar-cart').attr('aria-hidden', 'false');
         $(document).find('.PageOverlay').addClass('is-visible');
        },1000)
      }
    });
  });

  $(document.body).on('change','.Modal--quickbuy .ProductForm.cstm-prdct-form .ProductForm__Option.ProductForm__Option--labelled input[type="radio"]', function() 
  {
    var val = $(this).val();
    $(this).closest('form').find('select[name="id"] option:selected').removeAttr('selected');
    var option_name = '';
    var arrString = '';
    var arrString_ = '';
    var arrString__ = '';
   var arr = [];
   var thelistunique = '';
    var select_val_option = '';
    $(this).closest('form').find(".ProductForm__Option li").each(function( index ){
  var input_vlue = $(this).closest('.SizeSwatchList').find('.cstm_active').val();
      
  if( input_vlue == "undefined" || input_vlue == "" ){}
  else {
    arr.push(input_vlue);
    // console.log(input_vlue + index, arr);
  var thelistunique = arr.filter(function(a){
    if (!this[a]) {
      this[a] = 1;
      return a;
    }},{});
    // var max_length_list = $(thelistunique).length;
    arrString = thelistunique[0];
    arrString_ = thelistunique[1];
    arrString__ = thelistunique[2];
    if(arrString && arrString_ && arrString__){
      option_name = arrString + " / "+ arrString_ + " / " + arrString__;
    }else if(arrString && arrString_){
      option_name = arrString + " / "+ arrString_;
    }else if(arrString){
      option_name = arrString;
    }
  }
});
var select_val = '';
    $(this).closest('form').find(".ProductForm__Option select option").each(function( index ){
      var select_val = $(this).attr('data-var');
      if( option_name == select_val ){
      select_val_option = $(this).val();
        $(this).attr('selected', 'selected');
     } else {
   // console.log('not');
     }
      // console.log(select_val_option, 'select_val_options');
  });
 
    
  
  
  });

   
   
  $('.Drawer__Close[data-drawer-id="sidebar-cart"]').on('click',function(){
    $('#sidebar-cart').attr('aria-hidden', 'true');
    $(document).find('.PageOverlay').removeClass('is-visible');
  });
  $('.PageOverlay').on('click',function(){
    $(document).find('.PageOverlay').removeClass('is-visible');
    $('.ProductList').removeClass('cstm-transform-none');
    $('#sidebar-cart').attr('aria-hidden', 'true');
  });
}); 

$(document).ready(function(){
  $('.showShipAddress').on('click',function(e){
	e.preventDefault();
    $('.ShipAddress').hide();
    $('.chooseShipAddress').show();
  });
  $('.showBillAddress').on('click',function(e){
	e.preventDefault();
    $('.BillAddress').hide();
    $('.chooseBillAddress').show();
  });
  
  $('.usethisaddress').on('click',function(e)
  {
		var address_method = $(this).data('address-method');
    	var address_id = $(this).data('address-id');
    	var address_id_selector = $($(this).data('address-selector'));
    	var first_name = address_id_selector.data('first_name');
    	var last_name = address_id_selector.data('last_name');
    	var company = address_id_selector.data('company');
    	var address1 = address_id_selector.data('address1');
    	var address2 = address_id_selector.data('address2');
    	var city = address_id_selector.data('city');
    	var country = address_id_selector.data('country');
    	var zip = address_id_selector.data('zip');
    	var phone = address_id_selector.data('phone');
    	var add_id = address_id_selector.data('address_id');
    
        var AccountAddress = $('.single-address.add-'+address_id+' .Segment__Content p.AccountAddress').html();
    
    	//console.log('#customer_'+address_method+'_first_name');
    
    	$('#customer_'+address_method+'_first_name').val(first_name);
    	$('#customer_'+address_method+'_last_name').val(last_name);
    	$('#customer_'+address_method+'_company').val(company);
    	$('#customer_'+address_method+'_address1').val(address1);
    	$('#customer_'+address_method+'_address2').val(address2);
    	$('#customer_'+address_method+'_city').val(city);
    	$('#customer_'+address_method+'_country').val(country);
    	$('#customer_'+address_method+'_zip').val(zip);
    	$('#customer_'+address_method+'_phone').val(phone);
    	$('#customer_'+address_method+'_address_id').val(add_id);

    	if(address_method == "billing")
        {
          $(".BillAddress .Segment__Content p.AccountAddress").html(AccountAddress);
          $('.BillAddress').show();
          $('.chooseBillAddress').hide();
        }
    
       	if(address_method == "shipping")
        {
          $(".ShipAddress .Segment__Content p.AccountAddress").html(AccountAddress);
          $('.ShipAddress').show();
          $('.chooseShipAddress').hide();
          
          var country_value = $('.ShippingEstimator__Country select[name="country"] option:contains("'+country+'")').val();
          // console.log("country_value" + country_value);
          $('.ShippingEstimator__Country select[name="country"]').val(country_value);
          
          $('.ShippingEstimator__Zip.Form__Input').val(zip);
          $(".ShippingEstimator__Submit").trigger('click');
          
          /*setTimeout(function()
          { 
            var selector = $('.ShippingEstimator__ResultsInner ul li');
            var length = selector.length;
            var shipping_html = '<h2 class="Segment__Title Heading u-h7">shipping method</h2>';
            var shipping_html_row = '<div><label><input type="radio" name="shippingMethod" data-title="shipping_value" value="shipping_value"><span>shipping_value</span></label></div>';
            $(selector).each(function( index ) 
            {
              var shipping_html_row_replace = shipping_html_row.replaceAll("shipping_value",$( this ).text());
              shipping_html = shipping_html + shipping_html_row_replace;
              if (index === (length - 1)) 
              {
                $(".shipping-method").html(shipping_html);
              }
            });
          },1000);*/
          
        }
    
        $('html, body').animate({
          scrollTop: $("#invoiceForm").offset().top
        }, 500);
  });
  
  /*
  $("#address_form_new").submit(function(event){
    event.preventDefault(); //prevent default action 
    var post_url = $(this).attr("action"); //get form action url
    var request_method = $(this).attr("method"); //get form GET/POST method
    var form_data = new FormData(this); //Creates new FormData object
    $.ajax({
      url : post_url,
      type: request_method,
      data : form_data,
      contentType: false,
      cache: false,
      processData:false
    }).done(function(response)
            { //
      console.log(response);
    });
  });
  */
  var current_url = window.location.href;
  var check_if_added = current_url.includes("/cart?address_added=1");
  if(check_if_added)
  {
    invoiceButtonClick();
    setTimeout(function()
    {  
      $('html, body').animate({
        scrollTop: $("#invoiceForm").offset().top
      }, 500);

    }, 1000);
  }
  
  var preferredPosition = 'bottom';
      var preferredAlignment = undefined;
      var threshold = 20;
      var isOpen = false;

      var onValueChanged = function (element, activator) {};
      var onOpen = function (element, activator) {};
      var onClose = function (element, activator) {};

      var showOverlay = true;
      var pageOverlayElement = document.querySelector('.PageOverlay');
  
  var elm = '';
  var act = '';
  
  
  
  var closePop = function(element, activator) {
	if (!isOpen) {
          return;
    }
    
    element.attr('aria-hidden', 'true');
    activator.attr('aria-expanded', 'false');
    
    //document.documentElement.classList.remove('no-scroll');
    
    if (showOverlay) {
      //pageOverlayElement.classList.remove('is-visible');
      //pageOverlayElement.removeEventListener('click', _closeListener);
    }
    
    onClose(element, activator); // Call the callback to allow other code to hook their logic
    isOpen = false;
    
    elm = '';
  	act = '';
  }
  
  var _position = function(element, activator) {
    var topPosition = 0,
            rightPosition = 0,
            position = '',
            alignment = '',
            threshold = 20;
    var activatorBoundingRect = activator.get(0).getBoundingClientRect(),
              halfHeight = windowHeight / 2;
    var win = $('.Modal--quickbuy[aria-hidden="false"]');
    
    var windowHeight = win.innerHeight();
    
    
    if (preferredPosition === 'bottom') {
            alignment = 'right';

            if (element.height() <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
              position = 'bottom';
            } else {
              position = 'top';
            }
          } else if (preferredPosition === 'top') {
            alignment = 'right';

            if (element.height() <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
              position = 'top';
            } else {
              position = 'bottom';
            }
          } else {
            position = 'left';

            // Is there enough space to use the center alignment (which is preferred)?
            var halfElementHeight = element.height() / 2;

            if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'center';
            } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
              alignment = 'bottom';
            } else {
              alignment = 'top';
            }
          }
    
    	if (preferredAlignment) {
            alignment = preferredAlignment;
          }

          if (position === 'top') {
            topPosition = activatorBoundingRect.top - element.height() - threshold;

            if (alignment === 'center') {
              rightPosition = win.innerWidth() - activatorBoundingRect.right - element.width() / 2 + 3;
            } else {
              rightPosition = win.innerWidth() - activatorBoundingRect.right;
            }
          } else if (position === 'bottom') {
            topPosition = activatorBoundingRect.bottom + threshold;

            if (alignment === 'center') {
              rightPosition = win.innerWidth() - activatorBoundingRect.right - element.width() / 2 + 3;
            } else {
              rightPosition = win.innerWidth() - activatorBoundingRect.right;
            }
          } else {
            rightPosition = win.innerWidth() - activatorBoundingRect.left + threshold;

            if (alignment === 'center') {
              topPosition = activatorBoundingRect.top - element.height() / 2 + activator.height() / 2;
            } else if (alignment === 'top') {
              topPosition = activatorBoundingRect.bottom - element.height();
            } else {
              topPosition = activatorBoundingRect.top;
            }
          }
  
    
    	['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
            element.removeClass(item);
          });
    
    	element.addClass('Popover--positionBottom');
         element.addClass('Popover--alignRight');
    
        //element.addClass('Popover--position' + (position.charAt(0).toUpperCase() + position.slice(1)));
        //element.addClass('Popover--align' + (alignment.charAt(0).toUpperCase() + alignment.slice(1)));
        // element.attr('style', 'top: ' + parseInt(topPosition) + 'px; right: ' + parseInt(rightPosition) + 'px;');
  }
  
  var openPop = function(element, activator) {
    if (isOpen || activator.attr('aria-controls') !== element.attr('id')) {
          return;
    }
   
    element.attr('aria-hidden', 'false');
    activator.attr('aria-expanded', 'true');
    //document.documentElement.classList.add('no-scroll');
    activator.removeAttr('style');
    _position(element, activator);

    if (showOverlay) {
      //pageOverlayElement.classList.add('is-visible');
      //pageOverlayElement.addEventListener('click', _closeListener);
    }
    
    onOpen(element, activator); // Call the callback to allow other code to hook their logic
    isOpen = true;
    
    elm = element;
  	act = activator;
  }
  
  var togglePop = function(element, activator) {
    isOpen ? closePop(element, activator) : openPop(element, activator);
  }
  
  var _clickOutside = function(element, activator) {
	if (!element.closest('.Popover') && !element.closest('.Modal') && element.target !== activator && !activator.contains(element.target)) {
          closePop(element, activator);
    }
  }
  
  var handleKeyboard = function(element, activator) {
    if (isOpen && element.keyCode === 27) {
          closePop(element, activator);
    }
  }
  
  var _onFocusOut = function(element, activator) {
    if (isOpen && element.keyCode === 27) {
          closePop(element, activator);
    }
  }
  
  var _valueChanged = function(element, activator, elm) {
    var elm_id = element.attr('id');
    element.find( ".Popover__ValueList button" ).each(function( index ) {
      $(this).removeClass('is-selected');
    });
    
    elm.addClass('is-selected');
    
      var value = elm.attr('data-value');
      var jsonData = JSON.parse(elm.closest('.Modal--quickbuy').find('[data-product-json]').html());
      var productData = jsonData['product'];
      var variantsInventories = jsonData['inventories'] || {};
      var masterSelector = elm.closest('.Modal--quickbuy').find('#product-select-' + productData['id']);
      var currentVariant = '';
      var option1 = '';
      var option2 = '';
      var option3 = '';
      var found = false;
    // We init value with the first selected variant
      productData['variants'].forEach(function (variant) {
        if (variant['id'] === jsonData['selected_variant_id']) {
          currentVariant = variant;
          option1 = variant['option1'];
          option2 = variant['option2'];
          option3 = variant['option3'];
        }
        if (variant['option1'] === value || variant['option2'] === value || variant['option3'] === value) {
            found = variant;
        }
      });
    
    element.closest('.Modal--quickbuy').find('.ProductForm__Variants').find('.ProductForm__Item[aria-controls="'+elm_id+'"]').find('.ProductForm__SelectedValue').html(value);
    var productMetaPrices = elm.closest('.Modal--quickbuy').find('.ProductMeta__PriceList');
    var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
    var cd = elm.closest('.ProductItem__Wrapper').find('.customer--discount').val();
    var priceHtml = '';

    if (found['compare_at_price'] > found['price']) {
      priceHtml += '<span class="ProductMeta__Price Price Price--highlight Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'], currencyFormat) + '</span>';
      priceHtml += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['compare_at_price'], currencyFormat) + '</span>';
    } else {
      if(cd != undefined){
        priceHtml += '<span class="ProductMeta__Price Price Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'] * cd, currencyFormat) + '</span>';
        priceHtml += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'], currencyFormat) + '</span>';
      } else {
      	priceHtml += '<span class="ProductMeta__Price Price Text--subdued" data-money-convertible>' + Shopify.formatMoney(found['price'], currencyFormat) + '</span>';
      }   
    }
    
    productMetaPrices.html(priceHtml);
    masterSelector.find('[selected]').removeAttr('selected');
    masterSelector.find('[value="' + found['id'] + '"]').attr('selected', 'selected');
    masterSelector.val(found['id']).change();
	closePop(element, activator);
  }
  
  var _attachListeners = function(element, activator) {
  	handleKeyboard(element, activator);
    _clickOutside(element, activator);
    //closePop(element, activator);
    togglePop(element, activator);   
    //element.addEventListener('keyup', _handleKeyboardListener);
    //activator.addEventListener('click', _toggleListener); 
    //this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
        //this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));
  	var id = element.attr('id');
    if (typeof attr !== 'undefined' && attr !== false) {
          _onFocusOut(element, activator);
    }
  }
  
  $(document).on('click', "body *",function(evt){
    if(elm != '' && act != ''){
    	_clickOutside(elm, act);
    }
  });
  
  $(document.body).on('click', '[data-action="close-popover"]',function(evt){
    if(elm != '' && act != ''){
    	closePop(elm, act);
    }	
  });
  
  $(document.body).on('click', '[data-action="select-value"]',function(evt){
    var $this = $(this);
    if(elm != '' && act != ''){    
    	_valueChanged(elm, act, $this);
    }
  });
  
  $(document.body).on('click', ".quickbuy-form-modal .ProductForm__Variants .ProductForm__Item",function(evt){
    evt.preventDefault();
    var element = $(this);
    element.closest('.Modal--quickbuy').find('.OptionSelector').attr('aria-hidden', 'true');
    element.closest('.Modal--quickbuy').find('.ProductForm__Item').attr('aria-expanded', 'false');
    var id = element.attr('aria-controls');
    var activator = $('.quickbuy-form-modal #' + element.attr('aria-controls'));
    _attachListeners(activator, element);
  });
  
    $(document.body).on('click', ".Button-Quickbuy",function(evt){
    evt.preventDefault();
    var element = $(this);
    element.closest('.ProductList').addClass('cstm-transform-none');
  });
  $(document.body).on('click', ".Modal--quickbuy .Modal__Close",function(evt){
    evt.preventDefault();
    var element = $(this);
    element.closest('.ProductList').removeClass('cstm-transform-none');
  });
  
});

$(document).ready(function(){
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    let var_id = variant.id;
    let metafld_var_id = '';
   // let btn_flag = false;
    $( ".cstm_metafield_btn .cstm_btn_mtfld" ).each(function() {
      metafld_var_id = $(this).attr('data-id');
      $(this).removeClass('cstm_metafield_btn_show');
      
      
      if(var_id == metafld_var_id){
      //  btn_flag = true;
       $(this).addClass('cstm_metafield_btn_show');
        
      }
    });
    // if(btn_flag) {
    // 	$('.ProductForm__AddToCart_cstm').addClass('hide-btn');
    // } else {
    // 	$('.ProductForm__AddToCart_cstm').removeClass('hide-btn');
    // }
  });
});


  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };
    var _CartDrawerRecommendations = class extends HTMLElement {
    async connectedCallback() {
      if (!_CartDrawerRecommendations.recommendationsCache[this.productId]) {
        _CartDrawerRecommendations.recommendationsCache[this.productId] = fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`);
      }
      const response = await _CartDrawerRecommendations.recommendationsCache[this.productId];
      //console.log('response',response);
      const div = document.createElement("div");
      div.innerHTML = await response.clone().text();
      const productRecommendationsElement = div.querySelector("cart-drawer-recommendations");
      //console.log('productRecommendationsElement',productRecommendationsElement);
      if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
        this.innerHTML = productRecommendationsElement.innerHTML;
        //console.log('productRecommendationsElement.innerHTML',productRecommendationsElement.innerHTML);
      } else {
        this.hidden = true;
      }
    }
    get productId() {
      return this.getAttribute("product-id");
    }
    get sectionId() {
      return this.getAttribute("section-id");
    }
  };
  var CartDrawerRecommendations = _CartDrawerRecommendations;
  __publicField(CartDrawerRecommendations, "recommendationsCache", {});
  if (!window.customElements.get('cart-drawer-recommendations')) {  
    window.customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
  }

var formatMoney = (cents, format) => {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    //return formatString.replace(placeholderRegex, value).replace(',00', '');
    return formatString.replace(placeholderRegex, value);
  } else {
    //return formatString.replace(placeholderRegex, value).replace('.00', '');
    return formatString.replace(placeholderRegex, value);
  }
}

// $(document.body).on('change', '.prdct-recommend-selector', function(){
//     var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
//     var selected_val = $(this).val();
//     $(this).closest('.ProductItem__Wrapper').find('.selected-option-value').val(selected_val);
//     var product_id = $(this).closest('.ProductItem__Wrapper').find('option:selected').attr('data-product-id');
//     var price = $(this).closest('.ProductItem__Wrapper').find('option:selected').attr('data-variant-price');
//     var compare_price = $(this).closest('.ProductItem__Wrapper').find('option:selected').attr('data-variant-compare-price');
//     var n = document.getElementById('#customer--discount--'+product_id);
//     var html = '';
//     if (compare_price > price) {
//       html += "<span class=\"ProductItem__Price Price Price--highlight Text--subdued\" data-money-convertible>".concat(formatMoney(price, currencyFormat), "</span>");
//       html += "<span class=\"ProductItem__Price Price Price--compareAt Text--subdued\" data-money-convertible>".concat(formatMoney(compare_price, currencyFormat), "</span>");
//     } else {
//       if (null != n) {
//         var s = n.value;
//             html += "<span class=\"ProductItem__Price Price Price--highlight Text--subdued\" data-money-convertible>".concat(formatMoney(price * s, currencyFormat), "</span>");
//             html += "<span class=\"ProductItem__Price Price Price--compareAt Text--subdued\" data-money-convertible>".concat(formatMoney(price, currencyFormat), "</span>");
//       } else {
//         html += "<span class=\"ProductItem__Price Price Text--subdued\" data-money-convertible>".concat(formatMoney(price, currencyFormat), "</span>");
//       }
//     }
//     $(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(html);
// });
// Add To Cart Drawer

$(document).on('click','.addtocart_btn .ProductForm__AddToCart[data-action="add-to-cart"]', function(e) {
   // console.log("click");
    e.preventDefault();
    var parent = $(this).parent('.addtocart_btn');
    var formData_text = $(this).closest('form').serialize();
    var qty_value = 1;
    var active_variant_id = $(this).closest('form').find('.variant_id').attr('value');
     document.dispatchEvent(new CustomEvent('theme:loading:start'));
    $.ajax({
      type:"POST",
      data: {"id": active_variant_id,"quantity": qty_value},
      url: '/cart/add.js',
      dataType: "json",
      success: function(data){
        __publicField(CartDrawerRecommendations, "recommendationsCache", {});
        if (!window.customElements.get('cart-drawer-recommendations')) {  
        window.customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        })); 
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        setTimeout(function(){
         $('#sidebar-cart').attr('aria-hidden', 'false');
         $(document).find('.PageOverlay').addClass('is-visible');
        },1000)
      }
    });
  });
$(document).on('click','.HorizontalList__Item', function(e) {
  var input_check = $(this).find('input').is(':checked');
  //console.log($(this).find('input').attr('value'))
  //console.log(input_check);
  $(this).closest('.SizeSwatchList').find('.cstm_active').removeClass('cstm_active');
  //console.log($(this).find('input').is(':checked'));
  $(this).find('input').addClass('cstm_active');
  if(input_check == true) {
    //console.log('in');
    $(this).find('input').addClass('cstm_active');
  };
    // Check Available product
  var input_vlue_available = $(this).find('input:checked').is('.not_available-product');
  var available_add_btn = $('.Modal--quickbuy').find('.ProductForm__AddToCart');
  var available_add_sold = $('.Modal--quickbuy').find('.sold_out-btn');
  var selected_value_price = $(this).find('input:checked').closest(".HorizontalList__Item").find(".ctm_data-variants").attr('data_variant_price');
  var selectbtn_price = $(this).find('input:checked').closest(".HorizontalList__Item").find(".ctm_data-variants").attr('data_variant_price_zero');
  var selectbtn_unitprice = $(this).find('input:checked').closest(".HorizontalList__Item").find(".ctm_data-variants").attr('data_unit_price');
  var selectbtn_measurementvalue = $(this).find('input:checked').closest(".HorizontalList__Item").find(".ctm_data-variants").attr('data_unit_measurementvalue');
  var selectbtn_measurementunit = $(this).find('input:checked').closest(".HorizontalList__Item").find(".ctm_data-variants").attr('data_unit_measurementunit');
  $(this).closest(".quickbuy-form-modal").find(".ProductMeta__PriceList .Price").html(selected_value_price);
  $(this).closest(".quickbuy-form-modal").find(".quick-view-price").html(selectbtn_price);
  $(this).closest(".quickbuy-form-modal").find(".UnitPriceMeasurement__Price").html(selectbtn_unitprice);
  $(this).closest(".quickbuy-form-modal").find(".UnitPriceMeasurement__ReferenceValue").html(selectbtn_measurementvalue);
  $(this).closest(".quickbuy-form-modal").find(".UnitPriceMeasurement__ReferenceUnit").html(selectbtn_measurementunit);
  
  if(input_vlue_available == true) {
    $(available_add_sold).css("display", "block");
    $(available_add_btn).css("display", "none");
    $('.shopify-payment-button').css("display", "none");
  } else {
    $(available_add_sold).css("display", "none");
    $(available_add_btn).css("display", "block");
    $('.shopify-payment-button').css("display", "block");
  }
});

$(document.body).on('click', ".cstm_cart_btns .Button-Quickbuy",function(evt){
  evt.preventDefault();
  $(this).closest('body').find('.recommendations-left').addClass('is-active-element');
  $(this).closest('body').find('.PageOverlay').addClass('is-quickbuy-overlay');
  $(this).closest(".ProductItem__Wrapper").find(".Modal--quickbuy").attr("aria-hidden","false");
  $(this).closest('body').find('#sidebar-cart').addClass('quicky-actv');
});
$(document.body).on('click',".mini-cart__recommendations-list .Modal--quickbuy .Modal__Close",function(evt){
  evt.preventDefault();
  $(this).closest('body').find('.recommendations-left').removeClass('is-active-element');
  $(this).closest('body').find('.PageOverlay').removeClass('is-quickbuy-overlay');
  $(this).closest('body').find('.PageOverlay').addClass('is-cstm-active');
  $(this).closest(".ProductItem__Wrapper").find(".Modal--quickbuy").attr("aria-hidden","true");
  $(this).closest('body').find('#sidebar-cart').removeClass('quicky-actv');
});
$(document.body).on('click','#sidebar-cart .Drawer__Close', function(){
  $(this).closest('body').find('.PageOverlay').removeClass('is-cstm-active');
})
$(document.body).on('click','.PageOverlay', function(){
  $(this).removeClass('is-cstm-active');
  $(this).removeClass('is-quickbuy-overlay');
  $(this).closest('body').find('.recommendations-left').removeClass('is-active-element');
  $(this).closest("body").find(".Modal--quickbuy").attr("aria-hidden","true");
  $(this).closest('body').find('#sidebar-cart').removeClass('quicky-actv');
})

$(document.body).on('click','.is-active-element cart-drawer-recommendations .cart-drawer-recommendations-overlay', function(){
  $(this).removeClass('is-cstm-active');
  $(this).removeClass('is-quickbuy-overlay');
  $(this).closest('body').find('.recommendations-left').removeClass('is-active-element');
  $(this).closest("body").find(".Modal--quickbuy").attr("aria-hidden","true");
  $(this).closest('body').find('#sidebar-cart').removeClass('quicky-actv');
})
$(document).on('click','.recommendations_mobile .mini-cart__recommendations-list .quickbuy_drawer .Modal--quickbuy .quickbuy-form-modal [data-action="add-to-cart"]', function(e){
   // console.log("click");
    var option_name = '';
    var arrString0 = '';
    var arrString1 = '';
    var arrString2 = '';
    var arrString3 = '';
    var arrString4 = '';
   var arr = [];
   var thelistunique = '';
    var select_val_option = '';
    $(this).closest('.quickbuy_drawer').find(".ProductForm__Option li").each(function( index ){
  var input_vlue = $(this).closest('.SizeSwatchList').find('.cstm_active').val();
  if( input_vlue == "undefined" || input_vlue == "" ){}
  else {
    arr.push(input_vlue);
    // console.log(input_vlue + index, arr);
  var thelistunique = arr.filter(function(a){
    if (!this[a]) {
      this[a] = 1;
      return a;
    }},{});
    // var max_length_list = $(thelistunique).length;
    arrString0 = thelistunique[0];
    arrString1 = thelistunique[1];
    arrString2 = thelistunique[2];
    arrString3 = thelistunique[3];
    arrString4 = thelistunique[4];
    if (arrString0 && arrString1 && arrString2 && arrString3 && arrString4){
     option_name = arrString0 + " / "+ arrString1 + " / " + arrString2 + " / "+ arrString3 + " / " + arrString4; 
    } else if (arrString0 && arrString1 && arrString2 && arrString3) {
     option_name = arrString0 + " / "+ arrString1 + " / " + arrString2 + " / "+ arrString3; 
    }  else if (arrString0 && arrString1 && arrString2 ) {
     option_name = arrString0 + " / "+ arrString1 + " / " + arrString2 ; 
    }  else if (arrString0 && arrString1) {
     option_name = arrString0 + " / "+ arrString1; 
    }  else if (arrString0) {
     option_name = arrString0; 
    }
  }
});
var select_val = '';
    $(this).closest('.quickbuy_drawer').find(".ProductForm__Option select option").each(function( index ){
      var select_val = $(this).attr('data-var');
      if( option_name == select_val ){
      select_val_option = $(this).val();
        $(this).attr('selected', 'selected');
     } else {
   // console.log('not');
        
     }
      // console.log(select_val_option, 'select_val_options');
  });

    e.preventDefault();
    //console.log(select_val_option);
    var parent = $(this).parent('.Modal--quickbuy');
    var active_variant_id = $(this).closest('.quickbuy_drawer').find('select option:selected').attr('value');
    var qty_value = $(this).closest('.quickbuy_drawer').find('.QuantitySelector__CurrentQuantity').attr('value');
    var formData = {"id": active_variant_id,"quantity": qty_value}
    // var formData = $(this).closest('form').serialize();
    // var prdct_id = $(this).closest('form').attr('id');
    // console.log(formData, 'formData');
     document.dispatchEvent(new CustomEvent('theme:loading:start'));
    $.ajax({
      type:"post",
      dataType: "json",
      url: '/cart/add.js',
      data:formData,
      success: function(data){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        })); 
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        // parent.find('[data-action="close-modal"]').trigger('click');
        $('.modal-top button')[0].click();
        setTimeout(function(){
         $('#sidebar-cart').attr('aria-hidden', 'false');
         $(document).find('.PageOverlay').addClass('is-visible');
        },1000)
      }
    });
});
$(document.body).on('change','.recommendations_mobile .mini-cart__recommendations-list .quickbuy_drawer .Modal--quickbuy .quickbuy-form-modal .ProductForm__Option.ProductForm__Option--labelled input[type="radio"]', function() {
    var val = $(this).val();  
  //  console.log(val);
    $(this).closest('.quickbuy_drawer').find('select[name="id"] option:selected').removeAttr('selected');
    var option_name = '';
    var arrString = '';
    var arrString_ = '';
    var arrString__ = '';
   var arr = [];
   var thelistunique = '';
    var select_val_option = '';
    $(this).closest('.quickbuy_drawer').find(".ProductForm__Option li").each(function( index ){
  var input_vlue = $(this).closest('.SizeSwatchList').find('.cstm_active').val();
  if( input_vlue == "undefined" || input_vlue == "" ){}
  else {
    if(input_vlue == val){
    arr.push(input_vlue);
    }
  var thelistunique = arr.filter(function(a){
    if (!this[a]) {
      this[a] = 1;
      return a;
    }},{});
    arrString = thelistunique[0];
    arrString_ = thelistunique[1];
    arrString__ = thelistunique[2];
    if(arrString && arrString_ && arrString__){
      option_name = arrString + " / "+ arrString_ + " / " + arrString__;
    }else if(arrString && arrString_){
      option_name = arrString + " / "+ arrString_;
    }else if(arrString){
      option_name = arrString;
    }
  }
});
var select_val = '';
    $(this).closest('.quickbuy_drawer').find(".ProductForm__Option select option").each(function( index ){
      var select_val = $(this).attr('data-var');
      if( option_name == select_val ){
      select_val_option = $(this).val();
        $(this).attr('selected', 'selected');
     } else {
     }
  });
});